// @flow

import { RECEIVED_BLOG_SETTINGS } from './constants';
import type { ReceivedBlogSettings } from './actions';

const initialState = {
  blog_overview_link: '',
  blog_overview_link_label: '',
  share_label: '',
  read_more_label: '',
  load_more_label: '',
  latest_articles_label: '',
};

export type State = typeof initialState;

export default (state: State = initialState, action: ReceivedBlogSettings): State => {
  switch (action.type) {
    case RECEIVED_BLOG_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
